import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { lang, langKeys } from '../../core/i18n'
import routes from '../../core/routes'
import { useStore } from '../../stores'
import {
  AuthErrorText,
  AuthForm,
  Box,
  Button,
  RouteLink,
  Select,
  TextField,
} from '../index'

const LoginForm = observer((): JSX.Element => {
  const { t, i18n } = useTranslation()
  const { loginStore } = useStore()
  const [username, setUsername] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [isShowError, setIsShowError] = useState<boolean>(false)

  return (
    <Box data-cy="login-form-container">
      {isShowError && (
        <AuthErrorText data-cy="login-error-message">
          {t('loginOrPasswordErrorMessage')}
        </AuthErrorText>
      )}
      <AuthForm
        data-cy="login-form"
        onSubmit={async (e) => {
          e.preventDefault()
          setIsShowError(false)

          try {
            await loginStore.login({
              username,
              password,
            })
          } catch {
            setIsShowError(true)
          }
        }}>
        <Box mb={20}>
          <TextField
            value={username}
            label={t('login')}
            id="login"
            data-cy="login-username-input"
            onChange={(e) => {
              setUsername(e.target.value)
            }}
          />
        </Box>
        <Box mb={20}>
          <TextField
            value={password}
            label={t('password')}
            type="password"
            id="password"
            data-cy="login-password-input"
            onChange={(e) => {
              setPassword(e.target.value)
            }}
          />
        </Box>
        <Box mb={40}>
          <Select
            id="lang"
            label={t('lang')}
            value={langKeys[i18n.language]}
            options={lang}
            data-cy="login-language-select"
            onSelect={async (data) => {
              await i18n.changeLanguage(data.key)
            }}
          />
        </Box>
        <Box mb={40}>
          <Button
            fullWidth
            type="submit"
            label={t('signIn')}
            data-cy="login-submit-button"
          />
        </Box>
        <Box mb={20} display="flex" alignItems="center" justifyContent="center">
          <RouteLink to={routes.registration}>{t('registration')}</RouteLink>
        </Box>
        {/* <Box mb={20} display="flex" alignItems="center" justifyContent="center"> */}
        {/*   <RouteLink to={routes.restorePassword}> */}
        {/*     {t('restorePassword')} */}
        {/*   </RouteLink> */}
        {/* </Box> */}
      </AuthForm>
    </Box>
  )
})

export default LoginForm
